import { useMutation, useQuery } from "react-query";
import { queryClient } from "../../..";
import axios from "axios";

export const useGetAllChatsByThisUser = () =>
  useQuery({
    queryKey: ["allChatsByThisUser"],
    queryFn: () => axios.get("/api/aiChat/getAllChatsByThisUser").then((data) => data.data),
  });

export const useGetChatById = ({chatId, enabled}) =>
  useQuery({
    queryKey: ["getChatById", chatId],
    queryFn: () => axios.get(`/api/aiChat/getChatById/${chatId}`).then((data) => data.data),
    enabled
  });

/**
 * Topic-driven suggestion cards for the empty chat. The BE answers
 * { enabled: false } on legacy tenants and caches per tree version, so the
 * result is stable for a session — no refetch on focus, never retried.
 */
export const useGetAiChatSuggestions = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: ["aiChatSuggestions"],
    queryFn: () => axios.get("/api/aiChat/suggestions").then((data) => data.data),
    enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: 0,
  });

export const useDeleteChatById = () => {
  return useMutation(({chatId}) => axios.delete(`/api/aiChat/deleteChatById/${chatId}`), {
    onSuccess: (data, variables) => {
     queryClient.removeQueries(["getChatById", variables.chatId]); // ✅ Use variables.chatId
   },
  });
};


export const useSendFeedbackOnAskAIResponse = () => {
  return useMutation(({ reaction, comments, messageId, chatId }) =>
    axios.put(`/api/aiChat/sendFeedbackOnAskAIResponse/${chatId}`, { reaction, comments, messageId })
  );
};
